export default __webpack_public_path__ + "static/media/2、首页大无糖茶.7a288dcc.jpg";